import CommonAreaForm from "./CommonAreaForm";

export default function CommonAreasCreate({ state, handleUpdate, showPreviewImageCommon, onSubmit }) {
    return (
        <CommonAreaForm
            state={state}
            handleUpdate={handleUpdate}
            showPreviewImageCommon={showPreviewImageCommon}
            onSubmit={onSubmit}
            submitText="GUARDAR"
        />
    );
}
